
var History = {

    init: function() {


       var $second_year_slider = new Swiper( ".history-snap", {
            direction: 'vertical',
            slidesPerView:1,
            spaceBetween: 16,
            navigation: false,
            centeredSlides: true,
            rewind: false,
            watchSlidesProgress: true,
            mousewheel: {
                releaseOnEdges: true,
            },
            edgeSwipeDetection:true,
            touchReleaseOnEdges:true
          
        } );
       
        var $content_slider = new Swiper( ".history-content", {
            direction: 'vertical',
            autoHeight: true,
            slidesPerView:1,
            spaceBetween: 16,
            navigation: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
           
        } );

        var $images_slider = new Swiper( ".history-images", {
            direction: 'vertical',
            slidesPerView:1,
            spaceBetween: 16,
            navigation: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
           
        } );

       

        $( '.block-history' ).waypoint( function(direction  ) {
            $second_year_slider.mousewheel.disable();
        }, {
            offset: '110%'
        } );



         $( '.block-history .history-snap' ).waypoint( function(direction) {
            $second_year_slider.mousewheel.enable();
        }, {
            offset: '20%'
        } );


        $second_year_slider.on('slideChange', function (swiper) {
           var $index = swiper.realIndex;
           $content_slider.slideTo($index);
           $images_slider.slideTo($index);
           if( $(swiper.slides[$index]).data('century') == 19 ){
               $('.history-sticky-pre-transform').css("transform", "translate3d(0px, -100%, 0px)");
           }else{
              $('.history-sticky-pre-transform').css("transform", "translate3d(0px, 0%, 0px)");
           }
        });


   }
}

